// extracted by mini-css-extract-plugin
module.exports = {"table":"style-module__table___30hHu","tableColumn":"style-module__tableColumn___3bMPh"};